module.exports = __webpack_public_path__ + "img/karen-gillan.b0a73b73.jpg";